import Add from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import { Theme } from '@mui/material/styles';
import { t } from 'i18next';
import { useContext, useState } from 'react';

import { SmallLoadingButton } from '~components/Order/ordersDispatchStyledComponents';
import { useJob } from '~hooks/useJob/useJob';
import LoadsQueryContext from '~pages/Approvals/Files/components/JobsTable/ExpandedBlock/LoadsQueryContext';
import { useStores } from '~store';
import { alert, AlertTypes } from '~types/AlertTypes';
import { shouldAllowUserToAddNewLoads } from '~utils/loads/load-utils';

import ChargesBillingLinesQueryContext from '../ChargesBillingLinesQueryContext';

export default function ChargesAddLoadButton() {
  const { toasterStore, userStore } = useStores();
  const { job, refreshLoads, refreshParentJob } = useContext(LoadsQueryContext);
  const { reload } = useContext(ChargesBillingLinesQueryContext);
  const { addLoad } = useJob();
  const [isAdding, setIsAdding] = useState(false);

  if (!shouldAllowUserToAddNewLoads(job, userStore)) {
    return null;
  }

  const handleAddLoad = async () => {
    setIsAdding(true);

    try {
      const addedLoad = await addLoad(job.id, { material: job.material }).catch(
        () => null,
      );

      if (addedLoad) {
        toasterStore.push(alert(t('loads.load_added'), AlertTypes.success));
      }
    } finally {
      refreshLoads();
      refreshParentJob();
      reload();
      setIsAdding(false);
    }
  };

  return (
    <Box sx={footerSx}>
      <SmallLoadingButton
        color="secondary"
        loading={isAdding}
        onClick={handleAddLoad}
        startIcon={<Add />}
        variant="outlined"
      >
        {t('loads.add')}
      </SmallLoadingButton>
    </Box>
  );
}

const footerSx = (theme: Theme) => ({
  bgcolor: theme.semantic.surfaceOverlay,
  borderTop: `1px solid ${theme.brandV2.colors.treadGray7}`,
  p: 1.5,
});
